import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { fmtINR, fmtNum } from "@/lib/format";

const Tile = ({ red, label, value, sub, testid, live, children }) => (
  <div data-testid={testid} data-red={red ? "true" : "false"} className={`rounded-2xl border p-4 ${red ? "border-red-500/60 bg-red-500/15" : "border-slate-800 bg-slate-900"}`}>
    <div className="flex items-start justify-between gap-2">
      <p className={`flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider ${red ? "text-red-400" : "text-slate-400"}`}>
        {red && <AlertTriangle className="h-3.5 w-3.5" />}{label}
      </p>
      {live && <span data-testid={`${testid}-live-caption`} className="shrink-0 rounded bg-slate-950/60 px-1.5 py-0.5 text-[10px] font-medium text-slate-400 ring-1 ring-slate-700">Live, all dates</span>}
    </div>
    <p data-testid={`${testid}-value`} className={`mt-1 font-mono text-2xl font-semibold ${red ? "text-red-400" : "text-slate-50"}`}>{value}</p>
    {sub && <p data-testid={`${testid}-sub`} className={`text-xs ${red ? "text-red-400" : "text-slate-400"}`}>{sub}</p>}
    {children}
  </div>
);

export const LeakStrip = ({ leaks }) => (
  <section className="grid grid-cols-1 gap-3 sm:grid-cols-3" data-testid="leak-strip">
    <Tile testid="leak-booking-lag" red={leaks.booking_lag_red} label="Avg booking lag"
      value={leaks.avg_booking_lag_days === null ? "—" : `${fmtNum(leaks.avg_booking_lag_days)}d`} sub="Leak above 4 days" />
    <Tile testid="leak-aging" live red={leaks.aging_red} label="Follow-up aging 7+d" value={leaks.aging_count} sub="Follow-Up Ongoing, untouched">
      {leaks.aging_count > 0 && (
        <Link to="/leads?flag=aging" data-testid="leak-aging-link" className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-red-400 underline-offset-2 hover:underline">
          View aging leads <ArrowRight className="h-3 w-3" />
        </Link>
      )}
    </Tile>
    <Tile testid="leak-unpaid" live red={leaks.unpaid_red} label="Unpaid deposits 14+d" value={leaks.unpaid_deposits_count}
      sub={`${fmtINR(leaks.unpaid_deposits_sum)} outstanding deposits`} />
  </section>
);
